// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --aa-search-input-height: 3.25rem !important;
    --aa-selected-color-rgb: 241, 246, 234 !important;
    --aa-selected-color-alpha: 1 !important;
    --aa-text-color-rgb: 85, 85, 85 !important;
    --aa-text-color-alpha: 1 !important;
    --aa-muted-color-rgb: 117, 117, 117 !important;
    --aa-muted-color-alpha: 1 !important;
    --aa-panel-border-color-rgb: 221, 221, 221 !important;
    --aa-panel-border-color-alpha: 1 !important;
    --aa-search-input-height: 40px !important;
    --aa-input-border-color-rgb: 221, 221, 221 !important;
    --aa-input-border-color-alpha: 1 !important;
    .aa-ItemActionButton:nth-child(2) {
        display: none;
    }
    .aa-ItemActionButton:nth-child(1) svg:hover{
        fill:#C62D70;
    }
    .aa-ItemIcon svg {
        fill: #555555
    }

    .ais-RefinementList-label {
        display: inline-flex;
        align-items: center;
        cursor: pointer;
    }

    .ais-RefinementList-label span{
       margin-left: 10px;
    }

    .ais-RefinementList-checkbox{
        -webkit-appearance: none;
        appearance:none;
	    -webkit-border-radius: 2px;
	    -moz-border-radius: 2px;
	    border-radius: 2px;


        -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
	    -moz-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
	    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);  
 
        border: 1px solid #5555;
        background-color: #ffff;

        height: 16px;
        width: 16px;
        cursor: pointer;
    }
    .ais-RefinementList-checkbox:hover {
        border: 1px solid #C62D70;
        background-color: rgba(198,45,112,0.4);
    }
    .ais-RefinementList-checkbox:focus {
        -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18)!important;
           -moz-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18)!important;
                box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18)!important;
    }
    
    .ais-RefinementList-checkbox:checked::before{
        content: '\\2714';
        font-size: 12px;
        font-weight: lighter;
        color: #ffff;
        position:absolute;
        margin-top: 2px;
        margin-left: 2px;
    }
    .ais-RefinementList-checkbox:checked {
        background: #C62D70;
        border: 1px solid #C62D70;
        
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/AutocompleteSearch/algolia.css"],"names":[],"mappings":"AAAA;IACI,4CAA4C;IAC5C,iDAAiD;IACjD,uCAAuC;IACvC,0CAA0C;IAC1C,mCAAmC;IACnC,8CAA8C;IAC9C,oCAAoC;IACpC,qDAAqD;IACrD,2CAA2C;IAC3C,yCAAyC;IACzC,qDAAqD;IACrD,2CAA2C;IAC3C;QACI,aAAa;IACjB;IACA;QACI,YAAY;IAChB;IACA;QACI;IACJ;;IAEA;QACI,oBAAoB;QACpB,mBAAmB;QACnB,eAAe;IACnB;;IAEA;OACG,iBAAiB;IACpB;;IAEA;QACI,wBAAwB;QACxB,eAAe;KAClB,0BAA0B;KAC1B,uBAAuB;KACvB,kBAAkB;;;QAGf,gDAAgD;KACnD,6CAA6C;KAC7C,wCAAwC;;QAErC,uBAAuB;QACvB,uBAAuB;;QAEvB,YAAY;QACZ,WAAW;QACX,eAAe;IACnB;IACA;QACI,yBAAyB;QACzB,sCAAsC;IAC1C;IACA;QACI,2DAA2D;WACxD,wDAAwD;gBACnD,mDAAmD;IAC/D;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,oBAAoB;QACpB,YAAY;QACZ,iBAAiB;QACjB,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,mBAAmB;QACnB,yBAAyB;;IAE7B;AACJ","sourcesContent":[":root {\n    --aa-search-input-height: 3.25rem !important;\n    --aa-selected-color-rgb: 241, 246, 234 !important;\n    --aa-selected-color-alpha: 1 !important;\n    --aa-text-color-rgb: 85, 85, 85 !important;\n    --aa-text-color-alpha: 1 !important;\n    --aa-muted-color-rgb: 117, 117, 117 !important;\n    --aa-muted-color-alpha: 1 !important;\n    --aa-panel-border-color-rgb: 221, 221, 221 !important;\n    --aa-panel-border-color-alpha: 1 !important;\n    --aa-search-input-height: 40px !important;\n    --aa-input-border-color-rgb: 221, 221, 221 !important;\n    --aa-input-border-color-alpha: 1 !important;\n    .aa-ItemActionButton:nth-child(2) {\n        display: none;\n    }\n    .aa-ItemActionButton:nth-child(1) svg:hover{\n        fill:#C62D70;\n    }\n    .aa-ItemIcon svg {\n        fill: #555555\n    }\n\n    .ais-RefinementList-label {\n        display: inline-flex;\n        align-items: center;\n        cursor: pointer;\n    }\n\n    .ais-RefinementList-label span{\n       margin-left: 10px;\n    }\n\n    .ais-RefinementList-checkbox{\n        -webkit-appearance: none;\n        appearance:none;\n\t    -webkit-border-radius: 2px;\n\t    -moz-border-radius: 2px;\n\t    border-radius: 2px;\n\n\n        -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n\t    -moz-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n\t    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);  \n \n        border: 1px solid #5555;\n        background-color: #ffff;\n\n        height: 16px;\n        width: 16px;\n        cursor: pointer;\n    }\n    .ais-RefinementList-checkbox:hover {\n        border: 1px solid #C62D70;\n        background-color: rgba(198,45,112,0.4);\n    }\n    .ais-RefinementList-checkbox:focus {\n        -webkit-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18)!important;\n           -moz-box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18)!important;\n                box-shadow: 0 1px 2px rgba(0, 0, 0, 0.18)!important;\n    }\n    \n    .ais-RefinementList-checkbox:checked::before{\n        content: '\\2714';\n        font-size: 12px;\n        font-weight: lighter;\n        color: #ffff;\n        position:absolute;\n        margin-top: 2px;\n        margin-left: 2px;\n    }\n    .ais-RefinementList-checkbox:checked {\n        background: #C62D70;\n        border: 1px solid #C62D70;\n        \n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
